import { Radio, Tooltip } from 'antd'
import type { SignedDocumentApiItem } from 'features/Procedure/state/procedure-api.type'
import { memo, useCallback } from 'react'
import styles from './form-select.module.scss'

type Props = {
  doc: SignedDocumentApiItem
  selectedFormDocId: number | null
  onSelect: (doc: SignedDocumentApiItem) => void
}

const FormSelectComponent = ({ doc, selectedFormDocId, onSelect }: Props) => {
  const handleChange = useCallback(() => {
    onSelect(doc)
  }, [onSelect, doc])

  return (
    <button className={styles.container} onClick={handleChange}>
      <Radio
        value={doc.id}
        className='center'
        checked={selectedFormDocId === doc.id}
        onChange={handleChange}
      />
      <Tooltip title={doc.filename || ''} placement='right'>
        <div className={styles.tooltip} onClick={handleChange}>
          {doc.filename}
        </div>
      </Tooltip>
    </button>
  )
}

export const FormSelect = memo(FormSelectComponent, (prevProps, nextProps) => {
  return (
    prevProps.doc.id === nextProps.doc.id &&
    prevProps.selectedFormDocId === nextProps.selectedFormDocId
  )
})
